export default __webpack_public_path__ + "static/media/retangles-login.764e5bc6.svg";